export const SET_METADATA = 'metadata/SET'

const initialState = {
  title: process.env.REACT_APP_TITLE ? process.env.REACT_APP_TITLE : 'Catálogo de Prêmios | Premmiar',
  description: 'O WebPrêmios é um marketplace com design integrado que oferece uma experiência interativa ao participante, possibilitando a personalização do catálogo sem necessidade de envolvimento de técnicos ou intermediários. Entre suas facilidades estão telas de comparativo de preços, carrinho único, tracking, navegação com menos cliques, atendimento por chat e cross-selling de produtos.'
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_METADATA:
      return { ...state, ...action.metadata }
    default: return state
  }
}

export const setMetadata = metadata => ({
  type: SET_METADATA,
  metadata
})



// WEBPACK FOOTER //
// ./src/Shared/HeadMetadata/ducks.js